import React, { useState } from 'react';
import DocumentModal from '../components/extension/DocumentModal';

const AssignmentNumberCell = ({ assignmentNo }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <>
   <button
        type="button"
        onClick={handleClick}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: '#367c2b',
          textDecoration: 'none',
          cursor: 'pointer',
          fontWeight: 500,
        }}
        onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
        onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
      >
        {assignmentNo}
      </button>
      <DocumentModal 
        open={modalOpen}
        onClose={handleClose}
        assignmentNo={assignmentNo}
       
      />
    </>
  );
};

export default AssignmentNumberCell;
